
































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  METHODS,
  PAYMENT_GATEWAYS,
  STATUSES,
  SERVICE_PAYMENT_STATUSES,
} from '@/constants/payment';
import ServiceOrderCreateOrderReviewTable from './Create/ServiceOrderCreateOrderReviewTable.vue';
import QStripeServicePayment from '@/components/QStripeServicePayment.vue';
import ServiceOrderCreatePaymentGateways from './Create/ServiceOrderCreatePaymentGateways.vue';

@Component({
  components: {
    ServiceOrderCreateOrderReviewTable,
    QStripeServicePayment,
    ServiceOrderCreatePaymentGateways,
  },
  computed: {
    ...mapState('Auth', {
      candidate: 'candidate',
    }),
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
      paymentIntent: 'paymentIntent',
    }),
  },
})
export default class ServiceOrderRead extends Vue {
  @Prop({ default: false }) readonly needMarginTop!: boolean;

  isMounted = false;
  retryCount = 0;
  isPaying = false;
  timer: NodeJS.Timeout | null = null;
  candidate!: Model;
  activeServiceOrder!: Model;
  activeServicePayment!: Model;
  paymentIntent!: Model;
  paymentMethods = METHODS;
  paymentGateways = PAYMENT_GATEWAYS;
  paymentStatuses = SERVICE_PAYMENT_STATUSES;
  paymentTransactionStatuses = STATUSES;
  paymentGateway = '';
  isCreatePaymentIntent = false;
  isGeneratingInvoice = false;

  beforeMount() {
    this.init();
  }

  async init() {
    this.retryCount = 0;
    this.isPaying = true;
    while (this.retryCount < 5) {
      let oid;
      if (this.activeServiceOrder) {
        oid = this.activeServiceOrder.object_id;
      }
      if (this.$route.params.serviceOrderOid) {
        oid = this.$route.params.serviceOrderOid;
      }
      await this.$store.dispatch('ServiceOrder/fetch', oid);
      if (this.activeServicePayment.method == this.paymentMethods.INVOICE.key) {
        break;
      }
      if (!this.activeServicePayment._payment_transaction) {
        break;
      }
      if (
        [
          this.paymentTransactionStatuses.STATUS_SUCCEED.key,
          this.paymentTransactionStatuses.STATUS_FAILED.key,
        ].includes(this.activeServicePayment._payment_transaction.status)
      ) {
        break;
      }
      await this.wait(3000);
      this.retryCount += 1;
    }
    this.timer = null;
    this.isPaying = false;
    this.isMounted = true;
  }

  wait(ms) {
    return new Promise((resolve) => {
      this.timer = setTimeout(resolve, ms);
    });
  }

  get isFailed() {
    return (
      this.activeServicePayment._payment_transaction &&
      this.activeServicePayment._payment_transaction.status ===
        this.paymentTransactionStatuses.STATUS_FAILED.key
    );
  }

  get isCreated() {
    return (
      this.activeServicePayment._payment_transaction &&
      (this.activeServicePayment._payment_transaction.status ===
        this.paymentTransactionStatuses.STATUS_CREATED.key ||
        !this.activeServicePayment._payment_transaction.status)
    );
  }

  get isOpen() {
    return (
      this.activeServicePayment._payment_transaction &&
      (this.activeServicePayment._payment_transaction.status ===
        this.paymentTransactionStatuses.STATUS_OPEN.key ||
        !this.activeServicePayment._payment_transaction.status)
    );
  }

  get clientSecret() {
    return this.paymentIntent ? this.paymentIntent.client_secret : null;
  }

  async afterPay() {
    await this.init();
    this.$emit('paid');
  }

  newPaymentIntent() {
    this.isCreatePaymentIntent = true;
    const payload = {
      candidate_oid: this.candidate.object_id,
      payment_geteway: this.paymentGateway,
    };
    this.$store
      .dispatch('ServicePayment/newPaymentIntent', {
        object_id: this.activeServicePayment.object_id,
        payload,
      })
      .then((response) => {
        const { service_payment } = response.data.data;
        this.$store.commit(
          'ServicePayment/SET_ACTIVE_SERVICE_PAYMENT',
          service_payment
        );
        this.isCreatePaymentIntent = false;
      });
  }

  get invoiceAvailable() {
    return [this.paymentStatuses.STATUS_PAID.key].includes(
      this.activeServicePayment.status
    )
      ? true
      : false;
  }

  invoice() {
    this.isGeneratingInvoice = true;
    this.$store.dispatch('ServicePayment/invoice').then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Quescreen - ' + this.activeServicePayment.object_id;
      link.click();
      // URL.revokeObjectURL(link.href)
      this.isGeneratingInvoice = false;
      // this.$vs.loading.close('#download-pdf > .con-vs-loading')
    });
  }
}
